/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-21 14:47:46
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-10-08 15:48:46
 * @FilePath: \pit-bimwin-react-ui\src\components\PitModule\sectioning.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  FC,
  useState,
  // CSSProperties,
  // memo,
  // useCallback,
  // useRef,
  // useEffect,
} from 'react';
import styles from '../../styles/sectionAxis.module.scss';
interface pitModuleSectionAxisProps {}
const pitModuleSectionAxis: FC<pitModuleSectionAxisProps> = () => {
  const [modelActive, setModelActive] = useState('rotate');
  const [index, setindex] = useState(0);
  const [active, setactive] = useState(false);
  const [list] = useState(['x', 'y', 'z']);
  const handleModel = (type: string) => {
    setModelActive(type);
  };
  const handleClick = (item: string, i: number) => {
    console.log(item);
    setindex(() => i);
  };
  const hide = () => {
    setactive(proactive => !proactive);
  };
  const listNode = list.map((item, i) => {
    return (
      <div
        className={`${styles['section-axis-item']} ${
          index === i ? styles['active'] : ''
        }`}
        onClick={() => handleClick(item, i)}
        key={i}
      >
        {item}
      </div>
    );
  });
  return (
    <div>
      <div className={styles['button-wrapper']}>
        <div className={'pit-toolbar-bottom-item'}>
          <div
            className={`pit-button ${styles['pit-button']} ${
              styles['pit-button-prisim']
            } ${modelActive === 'rotate' ? styles['modelActive'] : ''}`}
            onClick={() => handleModel('rotate')}
          >
            旋转模式
          </div>
          <div
            className={`pit-button ${styles['pit-button']} ${
              styles['pit-button-prisim']
            } ${styles['pit-button-prisim']} ${
              modelActive === 'translate' ? 'modelActive' : ''
            }`}
            onClick={() => handleModel('translate')}
          >
            平移模式
          </div>
        </div>
      </div>

      <div className={styles['section-axis']}>
        {listNode}
        <div
          className={`pit-button pit-route pit-icon-test1 ${
            active ? styles['active'] : ''
          }`}
          title={active ? '显示' : '隐藏'}
          onClick={() => hide()}
        ></div>
      </div>
    </div>
  );
};
export default pitModuleSectionAxis;
